"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mixins = require("../../styles/mixins");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBTag = require("../HBTag/HBTag.types");
var _color = require("../../utils/color.utils");
/* Tag sizes */
var tagSizes = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBTag.TagSize.Small, {
  fontSize: '12px',
  height: '22px',
  borderRadius: '11px',
  padding: "0 ".concat(_spacing["default"][8])
}), _HBTag.TagSize.Medium, {
  fontSize: '14px',
  height: '30px',
  borderRadius: '15px',
  padding: "0 ".concat(_spacing["default"][12])
}), _HBTag.TagSize.Large, {
  fontSize: '16px',
  height: '40px',
  borderRadius: '20px',
  padding: "0 ".concat(_spacing["default"][16])
});

/* Tag themes */
var tagThemes = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBTag.TagTheme.Default, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBTag.TagState.Default, {
  background: "".concat(_colors["default"].neutral200),
  color: "".concat(_colors["default"].textPrimary)
}), _HBTag.TagState.Highlighted, {
  background: "".concat(_colors["default"].blue20),
  color: "".concat(_colors["default"].textWhite)
})), _HBTag.TagTheme.Accent, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBTag.TagState.Default, {
  background: "".concat((0, _color.applyOpacity)(_colors["default"].blue20, 16)),
  color: "".concat(_colors["default"].blue20)
}), _HBTag.TagState.Highlighted, {
  background: "".concat(_colors["default"].blue20),
  color: "".concat(_colors["default"].textWhite)
}));
var Tag = exports.Tag = _styledComponents["default"].div.withConfig({
  displayName: "HBTagstyles__Tag",
  componentId: "sc-ypxwr5-0"
})(["", " ", " ", ";", ";width:fit-content;line-height:1;cursor:", ";user-select:none;"], function (props) {
  return tagThemes[props.theme][props.state];
}, function (props) {
  return tagSizes[props.size];
}, _mixins.proximaNova, _mixins.flexCenterAll, function (props) {
  return props.isClickable ? 'pointer' : 'default';
});
//# sourceMappingURL=HBTag.styles.js.map